import { useState } from 'react';
import { JFormik, sortString } from '@centerpiece/components';
import * as Yup from 'yup';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  useGetRolesQuery,
  useDeleteRoleMutation,
  useUpdateRoleMutation,
  useCreateRoleMutation,
} from 'store/api';

export const RolesTab = () => {
  const [editing /*, setEditing*/] = useState<boolean>(false);
  const { data: roles = [], isLoading } = useGetRolesQuery({
    params: { type: 'Internal' },
  });
  const [createRole] = useCreateRoleMutation();
  const [editRole] = useUpdateRoleMutation();
  const [deleteRole] = useDeleteRoleMutation();
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <JFormik
      initialValues={() => ({
        roles: [...(roles || []).filter(role => role.type === 'Internal')].sort(
          (a, b) => sortString(a.name, b.name)
        ),
      })}
      handleSubmit={async (values, formik) => {}}
      loading={isLoading}
      validationSchema={
        editing
          ? Yup.object({
              name: Yup.string().required('Role name is required'),
              // type: Yup.string().nullable().required('Role type is required'),
            })
          : Yup.object({})
      }
      disabled={!editing}
      form={[
        {
          name: 'roles',
          itemType: 'table_array',
          label: 'Roles',
          tableProps: {
            onCreate: (values: any) =>
              createRole({ name: values.name, type: 'Internal' }),
            onEdit: (values: any) => editRole(values),
            onDelete: (id: number) => deleteRole(id),
            readOnly: (values: any) =>
              values?.subscription === undefined && values?.id > 0,
            // headers: [
            //   {
            //     name: 'name',
            //     label: '',
            //     itemType: 'textfield',
            //     jItemProps: {
            //       width: '100%',
            //       touched: true,
            //       sx: {
            //         boxSizing: 'border-box',
            //         px: { xs: 0.5 },
            //         minWidth: 180,
            //       },
            //     },
            //     gridProps: { xs: 12 },
            //   },
            //   // {
            //   //   name: 'type',
            //   //   label: "Type *",
            //   //   itemType: 'autocomplete',
            //   //   jItemProps: { width: '30%', touched: true, sx: { boxSizing: 'border-box', px: { xs: 0.5 }, minWidth: 160 } },
            //   //   gridProps: { xs: 12 },
            //   // },
            // ],
            columns: [
              {
                name: 'name',
                label: 'Role *',
                itemType: 'textfield',
                jItemProps: {
                  width: '70%',
                  touched: true,
                  sx: {
                    boxSizing: 'border-box',
                    px: { xs: 0.5 },
                    minWidth: 180,
                  },
                },
                gridProps: { xs: 12 },
              },
              // {
              //   name: 'type',
              //   label: "Type *",
              //   itemType: 'autocomplete',
              //   jItemProps: { width: '30%', touched: true, sx: { boxSizing: 'border-box', px: { xs: 0.5 }, minWidth: 160 } },
              //   options: ['Internal', 'External'],
              //   gridProps: { xs: 12 },
              // },
            ],
          },
          device: downMd ? 'mobile' : 'desktop',
        },
      ]}
    />
  );
};
